var _metadata, _defs, _rect, _g, _mask, _g2, _mask2, _g3, _mask3, _g4, _mask4, _g5, _mask5, _g6, _mask6, _g7, _mask7, _g8, _mask8, _g9, _mask9, _g0, _mask0, _g1, _mask1, _g10, _mask10, _g11, _mask11, _g12, _mask12, _g13, _mask13, _g14, _mask14, _g15, _mask15, _g16, _mask16, _g17, _mask17, _g18, _mask18, _g19, _mask19, _g20, _mask20, _g21, _mask21, _g22, _mask22, _g23, _mask23, _g24, _mask24, _g25, _mask25, _g26, _mask26, _g27, _mask27;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 7764.756519521066 987.9617235824353",
    width: 7764.756519521066,
    height: 987.9617235824353,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null)), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    className: "style-fonts"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 7764.756519521066,
    height: 987.9617235824353,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7752.676152579377 34.86067329097705) rotate(0 -433.33292643229106 458.6666615804038)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2.02 0.74 C-145.92 153.15, -720.39 762.89, -864.33 915.53 M2.08 -1.33 C-141.9 151.31, -720.47 764.75, -865.31 918.18",
    stroke: "#343a40",
    strokeWidth: 4,
    fill: "none"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7118.009811433545 48.19375231115873) rotate(0 0 328.00018310546875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.64 -0.82 C2.54 108.59, 1.23 546.95, 1.06 656.4 M0.62 -3.73 C0.1 106.19, -0.61 549.81, -0.6 660.24",
    stroke: "#343a40",
    strokeWidth: 4,
    fill: "none"
  })))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7110.01054385542 376.19424059240873) rotate(0 -201.33321126302144 -170.66670735677098)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.95 0.36 C-65.53 -56.64, -337.87 -285.76, -404.85 -342.96 M-0.44 -1.91 C-67.05 -58.5, -333 -283.77, -399.63 -340.22",
    stroke: "#343a40",
    strokeWidth: 4,
    fill: "none"
  })))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7094.010787996045 528.1937523111587) rotate(0 -488.00018310546875 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2.42 -0.33 C-164.47 -0.67, -811.97 -2.25, -974.54 -1.99 M1.46 -2.98 C-160.62 -3.03, -813.74 0.67, -975.98 0.55",
    stroke: "#343a40",
    strokeWidth: 4,
    fill: "none"
  })))), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6126.010299714795 528.1937523111587) rotate(0 -1.3332112630214397 -247.9999287923174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.89 -2.73 C1.9 -85.49, -0.44 -411.56, -1.29 -494.06 M-0.53 1.96 C-0.65 -80.36, -1.99 -415.09, -2.77 -498.02",
    stroke: "#343a40",
    strokeWidth: 4,
    fill: "none"
  })))), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6486.010299714795 544.193813346315) rotate(0 3.99993896484375 212.00027465820312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.83 -0.16 C0.69 70.45, 6.53 352.45, 8.11 423.59 M3.91 -2.71 C5.16 68.35, 5.39 356.11, 5.94 427",
    stroke: "#343a40",
    strokeWidth: 4,
    fill: "none"
  })))), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6126.010503165318 232.19399645178373) rotate(0 -388.0002848307304 372.0001220703125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.6 -0.02 C-128.46 124.04, -644.49 618.36, -773.93 742.79 M-2.52 -2.5 C-131.8 122.07, -645.82 621.61, -775.04 745.77",
    stroke: "#343a40",
    strokeWidth: 4,
    fill: "none"
  })))), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5862.01005557417 488.19405748694) rotate(0 -220 -228.00003051757812)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.95 -0.52 C-71.58 -75.75, -365.53 -377.35, -438.74 -453.55 M-0.44 -3.28 C-74.45 -79.04, -367.42 -381.85, -440.29 -457.23",
    stroke: "#343a40",
    strokeWidth: 4,
    fill: "none"
  })))), _mask8 || (_mask8 = /*#__PURE__*/React.createElement("mask", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5430.009933503858 40.19387438147123) rotate(0 4.000244140625 420)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2.63 -0.23 C-0.94 139.68, 8.08 699.23, 9.51 839.51 M1.14 -2.83 C2.65 137.53, 6.34 702.95, 8.09 842.88",
    stroke: "#343a40",
    strokeWidth: 4,
    fill: "none"
  })))), _mask9 || (_mask9 = /*#__PURE__*/React.createElement("mask", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5430.009933503858 520.1938743814712) rotate(0 -250.999755859375 -242.00000762939453)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.46 1.71 C-85.09 -79.07, -416.74 -405.77, -500.36 -486.29 M2.94 0.17 C-81.03 -80.19, -416.95 -402.95, -501.7 -483.9",
    stroke: "#343a40",
    strokeWidth: 4,
    fill: "none"
  })))), _mask0 || (_mask0 = /*#__PURE__*/React.createElement("mask", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5446.010299714795 744.193813346315) rotate(0 -521.3335164388027 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.34 -2.24 C-171.62 -1.53, -870.04 2.12, -1044.38 2.07 M0.16 2.71 C-172.83 2.85, -864.53 -1.23, -1038.91 -1.82",
    stroke: "#343a40",
    strokeWidth: 4,
    fill: "none"
  })))), _mask1 || (_mask1 = /*#__PURE__*/React.createElement("mask", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4406.010299714795 752.1939964517837) rotate(0 -12.0001220703125 -356.00006103515625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.99 0.28 C-5.63 -118.12, -20.64 -590.88, -24.02 -709.6 M2.13 -2.04 C-1.69 -121.24, -22.06 -595.49, -26.27 -713.31",
    stroke: "#343a40",
    strokeWidth: 4,
    fill: "none"
  })))), _mask10 || (_mask10 = /*#__PURE__*/React.createElement("mask", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4837.343002351521 759.5276756510007) rotate(0 3.99993896484375 100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2.21 -2.19 C-0.45 30.72, 6.98 164.43, 8.56 198.08 M1.79 2.79 C3.4 35.95, 6.07 167.36, 6.63 200.67",
    stroke: "#343a40",
    strokeWidth: 4,
    fill: "none"
  })))), _mask11 || (_mask11 = /*#__PURE__*/React.createElement("mask", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(884.5541029827182 17.698344695508695) rotate(180.46745691128993 -433.33292643229106 458.6666615804038)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.67 2.2 C-145.15 155.59, -723.79 766.11, -868.22 918.76 M4.17 0.93 C-139.28 153.63, -717.07 762.51, -862.66 914.53",
    stroke: "#343a40",
    strokeWidth: 4,
    fill: "none"
  })))), _mask12 || (_mask12 = /*#__PURE__*/React.createElement("mask", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(654.5723146142191 269.16395104057074) rotate(180.46745691128993 0 328.00018310546875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.55 1.43 C-1.54 110.53, -0.65 547.95, -0.61 656.81 M2.8 -0.26 C2.44 107.75, -2.08 542.71, -3.17 652.23",
    stroke: "#343a40",
    strokeWidth: 4,
    fill: "none"
  })))), _mask13 || (_mask13 = /*#__PURE__*/React.createElement("mask", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1063.403652283254 941.3742285292597) rotate(180.46745691128993 -201.33321126302144 -170.66670735677098)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.61 0.81 C-67.67 -56.56, -337.3 -286.19, -403.94 -342.77 M4.26 -1.22 C-63.15 -58.37, -339.31 -283, -406.87 -339.93",
    stroke: "#343a40",
    strokeWidth: 4,
    fill: "none"
  })))), _mask14 || (_mask14 = /*#__PURE__*/React.createElement("mask", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1651.050729288043 447.3607257713661) rotate(180.46745691128993 -488.00018310546875 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.28 -1.44 C-163.48 -1.13, -811.15 2.52, -973.8 2.64 M3.23 3.95 C-159.09 3.46, -811.03 -0.62, -974.85 -0.93",
    stroke: "#343a40",
    strokeWidth: 4,
    fill: "none"
  })))), _mask15 || (_mask15 = /*#__PURE__*/React.createElement("mask", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1649.9643222789455 947.8322640644142) rotate(180.46745691128993 -1.3332112630214397 -247.9999287923174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.2 2.64 C1.76 -79.89, -2.92 -413.12, -3.88 -496.66 M-0.06 1.61 C-0.86 -80.37, -5.81 -410.31, -6.77 -493.39",
    stroke: "#343a40",
    strokeWidth: 4,
    fill: "none"
  })))), _mask16 || (_mask16 = /*#__PURE__*/React.createElement("mask", null)), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1283.3457336461142 14.692381021004167) rotate(180.46745691128993 3.99993896484375 212.00027465820312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.21 -0.66 C-0.39 69.13, 5.88 350.25, 7.12 421.42 M3.33 -3.49 C3.5 67.76, 2.94 352.71, 4.41 423.65",
    stroke: "#343a40",
    strokeWidth: 4,
    fill: "none"
  })))), _mask17 || (_mask17 = /*#__PURE__*/React.createElement("mask", null)), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2421.8938052118283 9.175763119344538) rotate(180.46745691128993 -388.0002848307304 372.0001220703125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.88 -2.58 C-130.3 121.92, -648.1 622.11, -777.73 746.37 M3.84 2.19 C-124.56 126.01, -642.75 618.76, -772.27 742.64",
    stroke: "#343a40",
    strokeWidth: 4,
    fill: "none"
  })))), _mask18 || (_mask18 = /*#__PURE__*/React.createElement("mask", null)), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2349.317650112538 952.4364097619805) rotate(180.46745691128993 -220 -228.00003051757812)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.73 2.37 C-75.36 -73.38, -369.59 -380.36, -442.64 -457.06 M2.53 1.18 C-70.19 -73.94, -363.61 -377.85, -437.67 -454.01",
    stroke: "#343a40",
    strokeWidth: 4,
    fill: "none"
  })))), _mask19 || (_mask19 = /*#__PURE__*/React.createElement("mask", null)), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2337.453265932014 110.76601232385974) rotate(180.46745691128993 4.000244140625 420)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2.64 -1.06 C-1.02 138.24, 6.18 698.4, 8 838.16 M1.12 -4.1 C2.53 136.74, 4.84 700.23, 5.76 840.8",
    stroke: "#343a40",
    strokeWidth: 4,
    fill: "none"
  })))), _mask20 || (_mask20 = /*#__PURE__*/React.createElement("mask", null)), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2845.14863292675 952.6692732280658) rotate(180.46745691128993 -250.999755859375 -242.00000762939453)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -1.84 C-83.18 -82.74, -418.32 -406.11, -501.72 -486.48 M-3.45 3.34 C-86.74 -77.21, -420.83 -403.47, -503.81 -484.19",
    stroke: "#343a40",
    strokeWidth: 4,
    fill: "none"
  })))), _mask21 || (_mask21 = /*#__PURE__*/React.createElement("mask", null)), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3365.8961706121954 228.07655597882285) rotate(180.46745691128993 -518.5910857407634 9.224251920300048)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.28 -2.48 C-172.32 0.89, -862.52 14.57, -1035.59 18.39 M-3.02 2.35 C-175.85 6.36, -864.06 19.72, -1036.97 21.99",
    stroke: "#343a40",
    strokeWidth: 4,
    fill: "none"
  })))), _mask22 || (_mask22 = /*#__PURE__*/React.createElement("mask", null)), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3392.3886389635372 957.9413184583459) rotate(180.46745691128993 -12.0001220703125 -356.00006103515625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.59 -0.06 C-2.62 -117.98, -20.4 -591.63, -24.96 -710.01 M-0.99 -2.56 C-5.68 -121.03, -24.58 -595.2, -27.72 -713.95",
    stroke: "#343a40",
    strokeWidth: 4,
    fill: "none"
  })))), _mask23 || (_mask23 = /*#__PURE__*/React.createElement("mask", null)), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2927.9809383722386 30.722709286042573) rotate(180.46745691128993 3.99993896484375 100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.96 1.99 C-0.18 35.6, 5.13 169.02, 6.26 201.63 M3.72 0.6 C5.26 33.41, 10.43 164.36, 11.72 197.51",
    stroke: "#343a40",
    strokeWidth: 4,
    fill: "none"
  })))), _mask24 || (_mask24 = /*#__PURE__*/React.createElement("mask", null)), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3389.342310619755 48.86099372554554) rotate(0 500 454.00001525878906)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.67 -0.89 C167.44 150.32, 835.14 757.7, 1001.75 909.42 M-2.41 -3.84 C164.04 146.35, 833.61 753.77, 1000.47 905.18",
    stroke: "#343a40",
    strokeWidth: 4,
    fill: "none"
  })))), _mask25 || (_mask25 = /*#__PURE__*/React.createElement("mask", null)), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3385.3426768306927 436.8608207926022) rotate(0 216.66666666666606 1.33331298828125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.37 -0.87 C72.42 -0.1, 361.59 4.43, 433.57 5.24 M-2.88 -3.81 C68.71 -3.82, 359.34 1.13, 431.46 1.62",
    stroke: "#343a40",
    strokeWidth: 4,
    fill: "none"
  })))), _mask26 || (_mask26 = /*#__PURE__*/React.createElement("mask", null)), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4389.342615795536 572.8608818277585) rotate(0 -209.33319091796875 -3.33338419596339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.85 -2.48 C-70.45 -2.81, -349.89 -3.53, -419.33 -3.98 M3.89 2.34 C-65.99 1.48, -351.5 -5.48, -421.92 -7.54",
    stroke: "#343a40",
    strokeWidth: 4,
    fill: "none"
  })))), _mask27 || (_mask27 = /*#__PURE__*/React.createElement("mask", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooter);
export default __webpack_public_path__ + "static/media/Footer.13d096e36db39748b42612d3df729e53.svg";
export { ForwardRef as ReactComponent };